<template>
  <v-card>
    <v-card-title>
      <span>
        <v-icon>mdi-book-open-page-variant</v-icon> Articolo
      </span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <editor
        api-key="ea4ql1hfbqxnimnj211yaqu84qssg624lp5q7ayzqt7rmoon"
        v-model="newArticle.content"
        plugins="image imagetools media link lists fullscreen table"
        :init="{height: 500, media_dimensions: false}"
      ></editor>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'

  import Editor from '@tinymce/tinymce-vue';

  export default {
    name: 'app',
    components: {
      Editor
    },
    data() {
      return {}
    },
    computed: {
      ...mapGetters([
        'newArticle'
      ])
    },
    watch: {
      content(val) {
        this.$store.commit('SET_ARTICLE_CONTENT', val)
      }
    },
    mounted() {
      console.log(this.$refs.editor)
    }
  }
</script>